import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { useStatus } from '@store/session';
import { Fetch } from '@store/session/service';
import { classNames } from '@src/utils';
var prefixCls = 'middleware-page';
var className = classNames('page', prefixCls);
var MiddlewarePage = function () {
    var dispatch = useDispatch();
    var history = useHistory();
    var location = useLocation();
    var unauthorized = useStatus('unauthorized');
    var fetching = useStatus('fetching');
    var logged = useStatus('logged');
    var token = window.location.search.split('=')[1];
    if (token !== void 0) {
        sessionStorage.setItem('token', token);
        history.replace('/');
    }
    useEffect(function () {
        // 若用户已登录，且认证未失效，则跳转到首页。
        if (logged === true && unauthorized === false) {
            var referrer = location.state.referrer;
            if (referrer !== void 0 && referrer !== null) {
                history.replace(referrer.pathname);
            }
            else {
                history.replace('/');
            }
        }
        // 获取当前用户信息
        else if (fetching !== true) {
            dispatch(Fetch({}));
        }
        return function () {
            /** 清理函数产生的副作用 */
        };
    }, [unauthorized, logged, fetching, history, location, dispatch]);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: prefixCls + "_loading" }, "\u52A0\u8F7D\u4E2D...")));
};
export default React.memo(MiddlewarePage);
